import { call, put, takeLatest } from "redux-saga/effects";
import { ApiResponse } from "models";
import { BrandPayload } from "models/brand";
import { PayloadAction } from "@reduxjs/toolkit";
// import { toast } from "react-toastify";
// import { paymentAction } from "./paymentSaga";
import paymentApi from "api/paymentApi";
import { paymentAction } from "./paymentSlice";
import { PaymentForm, RemovePayload } from "models/payment";
import { toast } from "react-toastify";

function* getPaymentList(action: PayloadAction<BrandPayload>) {
  try {
    const response: ApiResponse = yield call(
      paymentApi.getPaymentList,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(paymentAction.getPaymentSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    yield put(paymentAction.getPaymentFailed(errorData));
  }
}
function* addPayment(action: PayloadAction<PaymentForm>) {
  try {
    const response: ApiResponse = yield call(
      paymentApi.addPayment,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message || "Payment added successfully");
      yield put(paymentAction.addPaymentSuccess(data));
    } else {
      toast.error(data.message || "Failed to add payment");
      yield put(paymentAction.addPaymentFailed(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    toast.error(errorData?.message || "Error while adding payment");
    yield put(paymentAction.addPaymentFailed(errorData));
  }
}

function* getPaymentById(action: PayloadAction<BrandPayload>) {
  try {
    const response: ApiResponse = yield call(
      paymentApi.getPaymentById,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      yield put(paymentAction.getPaymentByIdSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    yield put(paymentAction.getPaymentByIdFailed(errorData));
  }
}

function* updatePayment(action: PayloadAction<PaymentForm>) {
  try {
    const response: ApiResponse = yield call(
      paymentApi.updatePayment,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(paymentAction.updatePaymentSuccess(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(paymentAction.updatePaymentFailed(errorData));
  }
}

function* deletePayment(action: PayloadAction<RemovePayload>) {
  try {
    const response: ApiResponse = yield call(
      paymentApi.deletePayment,
      action.payload
    );
    const data: ApiResponse = response.data;
    if (data.success) {
      toast.success(data.message);
      yield put(paymentAction.deletePaymentSuccess(data));
    }
  } catch (error: any) {
    const errorData = error?.response?.data;
    toast.error(errorData?.message || "Something went wrong");
    yield put(paymentAction.deletePaymentFailed(errorData));
  }
}
function* getInvoiceNumberList(action: PayloadAction<BrandPayload>) {
  try {
    // API call
    const response: ApiResponse = yield call(
      paymentApi.listAllInvoices,
      action.payload
    );
    const data: ApiResponse = response.data;

    if (data.success) {
      // success action dispatch
      yield put(paymentAction.getInvoiceNumberListSuccess(data));
    } else {
      // failure action dispatch (optional, if API returns success: false)
      yield put(paymentAction.getInvoiceNumberListFailed(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data;
    yield put(paymentAction.getInvoiceNumberListFailed(errorData));
  }
}
export function* getPaymentPdf(action: PayloadAction<any>) {
  try {
    const response: ApiResponse = yield call(
      paymentApi.getPaymentPdf,
      action.payload
    );
    const data: ApiResponse = response.data;

    if (data.success) {
      toast.success("PDF fetched successfully");
      yield put(paymentAction.getPaymentPdfSuccess(data));
    } else {
      toast.error(data.message || "Failed to fetch PDF");
      yield put(paymentAction.getPaymentPdfFailed(data));
    }
  } catch (error: any) {
    const errorData = error.response?.data || {
      message: "Something went wrong",
    };
    toast.error(errorData?.message || "Something went wrong");
    yield put(paymentAction.getPaymentPdfFailed(errorData));
  }
}

export default function* paymentSaga() {
  yield takeLatest(paymentAction.getPayment, getPaymentList);
  yield takeLatest(paymentAction.addPayment, addPayment);
  yield takeLatest(paymentAction.getPaymentById, getPaymentById);
  yield takeLatest(paymentAction.updatePayment, updatePayment);
  yield takeLatest(paymentAction.deletePayment, deletePayment);
  yield takeLatest(paymentAction.getPaymentPdfRequest.type, getPaymentPdf);
  yield takeLatest(
    paymentAction.getInvoiceNumberList.type,
    getInvoiceNumberList
  );
}
